import React from 'react';

interface PauseCircleIconProps {
  size?: number;
  color?: string;
}

/**
 * PauseCircleIcon Component
 * @description A circular pause icon with two vertical bars
 */
export const PauseCircleIcon: React.FC<PauseCircleIconProps> = ({ 
  size = 20, 
  color = '#101018' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 20 20"
    >
      <path 
        fill={color} 
        d="M4.109 15.892A8.333 8.333 0 1 1 15.687 3.904 8.333 8.333 0 0 1 4.109 15.892M7.5 6.667v6.666h1.667V6.667zm3.334 0v6.666H12.5V6.667z"
      />
    </svg>
  );
};

export default PauseCircleIcon;

